import { makeStyles } from '@material-ui/core/styles';
import fonts from 'styles/fonts';
import spacing from 'styles/spacing';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  container: {
    margin: `0 ${spacing.xxlarge}`,
    '& > *:not(:last-child)': {
      marginBottom: `${spacing.xxsmall}`,
    },

    '& > *:first-child': {
      margin: `${spacing.large} 0`,
    },
  },
  titleContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& > * + *': {
      marginLeft: `${spacing.xxxsmall}`,
    },
  },
  title: {
    color: colors.black,
    fontSize: fonts.sizes.xxlarge,
    letterSpacing: '0.15px',
    lineHeight: '24px',
    fontWeight: fonts.weights.medium,
  },
  subtitle: {
    textAlign: 'center',
    color: colors.black,
    fontSize: fonts.sizes.xlarge,
    letterSpacing: '0.15px',
    lineHeight: '24px',
    fontWeight: fonts.weights.medium,
  },
  text: {
    textAlign: 'center',
    fontSize: fonts.sizes.large,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: colors.black,
  },
  heading: {
    fontSize: fonts.sizes.medium,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: colors.black,
  },
  message: {
    fontSize: fonts.sizes.small,
    fontWeight: fonts.weights.normal,
    letterSpacing: '0.25px',
    lineHeight: '20px',
    color: colors.black,
    wordWrap: 'break-word',
    whiteSpace: 'pre-wrap',
  },
});

export default useStyles;
